import React, {Component} from 'react';
import {connect} from 'react-redux';
import {DFPLayout} from "./";
import accountActions from '../actions/account/account';
import { getNotifications, updateNotification } from '../actions/common/site_notifications';
import NotificationBar from '../../client/layouts/NotificationBar';
import { withCookies } from 'react-cookie';
import moment from 'moment';
import Navigation from "../components/dashboardNew/components/Navigation";
import ThemeCurtain from "../components/dashboardNew/objects/ThemeCurtain";
import SplashScreen from "../components/dashboardNew/objects/SplashScreen";


class SiteLayout extends Component {
    constructor() {
        super();
        this.state = {
            toggle: false,
        };
    }

    componentWillMount() {

        const personId = localStorage.getItem( 'person_id' ),
          { setAccount, getNotifications } = this.props;

        setAccount(personId);
        
        getNotifications(personId)        
    }

    componentDidUpdate( prevProps ) {
        if (prevProps.location.pathname !== this.props.location.pathname) {

            const { getNotifications } = this.props;
            const personId = localStorage.getItem('person_id');
            getNotifications(personId);
        }
    }
    
    renderNotifications = () => {

        const { site_notifications } = this.props;
        const currentNotifications = site_notifications.notifications && site_notifications.notifications.filter(elem =>  { 
                if ( (!elem.data.length) || ( !elem.data[0].completed && elem.repeat_notification && this.addDaysToDateHelper( elem.data[0].date_dismissed, elem.days_until_repeat) ) ) return true;
        } ) 

        let latestNotification;
     
        if (currentNotifications && currentNotifications.length) {

            latestNotification = currentNotifications[ currentNotifications.length - 1 ];

            return <NotificationBar
                noThanks={ this.noThanks }
                site_notification={ latestNotification }
            /> 
        } 
    }

    addDaysToDateHelper = ( date, noDays ) => {
        const todaysDate = moment();
            const dismissedDate = moment(date);
            
            const updatedDate = dismissedDate.add( noDays, 'days' );
    
            const isDueToday = updatedDate.isSameOrBefore(todaysDate, 'day');
            return isDueToday;
            
    }
    
    noThanks = ( notification ) => {
        const { updateNotification } = this.props;

        let data = {};
        data.notificationId = notification.id;
        data.personId = localStorage.getItem('person_id');

        if (notification.repeat_notification) {
            const date = moment();

            data.newDismissedDate = date.toISOString();
            updateNotification( data )

        } else {

            data.completed = 1;
            updateNotification( data )
        }
    };

    content(){
        return (
            <React.Fragment>
                <Navigation navClass='mobile-nav' />
                <ThemeCurtain />
                <SplashScreen />
            </React.Fragment>
        )
    }

    render() {
        const { children, location, account} = this.props;
        const isUserLoggedIn = localStorage.token;

        return (

            <DFPLayout
                account={account}
                pathname={location.pathname} >
                { this.renderNotifications() }
                { children }
                { isUserLoggedIn && this.content() }
            </DFPLayout>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account.account,
        site_notifications: state.site_notifications
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setAccount: ( personId ) => dispatch(accountActions.setAccount( personId ) ),
        getNotifications: (personId ) => dispatch( getNotifications( personId) ),
        updateNotification: ( data ) => dispatch( updateNotification( data ) ),
    };
};

export default withCookies( connect(mapStateToProps, mapDispatchToProps)(SiteLayout) );



// WEBPACK FOOTER //
// src/client/layouts/SiteLayout.jsx